import React, {  Component } from 'react'

import { Link } from 'react-router'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

const styles = {
	singleItem: {
		fontSize: "11pt"
	  , marginTop: "1vh"
	  , marginLeft: "2px"
	  , marginBottom: "1vh"
	},
	topItem: {
		fontSize: "11pt"
	  , marginTop: "1vh"
	  , marginLeft: "1px"
	},
	middleItem: {
		fontSize: "11pt"
	  , marginTop: "1px"
	  , marginLeft: "2px"
	},
	bottomItem: {
		fontSize: "11pt"
	  , marginLeft: "1px"
	  , marginBottom: "1vh"
	}
}

export default class LeftNavMenu extends Component{
	render(){
		return(
			<div
				style={{
						backgroundColor: "rgb(41, 48, 56)"
					  , width: "55px"
					  , height: "calc(100vh - 61px)"
					  , overflow: "hidden"
					  , float: "left"
					}}
					className="not-transparent"
			>
				<div
					style={{
						marginTop: "0"
					  , height: (typeof global.md.phone() == "string" || typeof global.md.tablet() == 'string')?"calc(100vh - 178px)" : "calc(100vh - 110px)"
					  , overflowY: "scroll"
					  , marginRight: "-300px"
					  , paddingRight: "300px"
					}}
				>
					<Divider style={{marginBottom: "10px"}} />
					<Link to={"/manager/projects"} style={{textDecoration: 'none'}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Projects">
							<img src={this.props.route[0]=="projects"?'/' + process.env.REACT_APP_NAME + "/static/img/Projects_green.png":'/' + process.env.REACT_APP_NAME + "/static/img/Projects.png"}
								style={{height: "25px !important", width: "22px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/tasks`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Tasks">
							<img src={this.props.route[0]=="tasks"?'/' + process.env.REACT_APP_NAME + "/static/img/tasks_g48.png":'/' + process.env.REACT_APP_NAME + "/static/img/tasks.png"}
								style={{height: "22px !important", width: "22px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/transactions`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "40px", width: "55px", textAlign:"center"}} title="Transactions">
							<img src={this.props.route[0]=="transactions"?'/' + process.env.REACT_APP_NAME + "/static/img/transactions_wallet_green.png":'/' + process.env.REACT_APP_NAME + "/static/img/transactions_wallet_w.png"}
								style={{width: "23px", marginLeft:"-3px"}}
							/>
						</div>
					</Link>
					<Divider style={{marginBottom: "12px", marginTop: "8px", width: "300px"}}/>
					<Link to={`/manager/properties`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Properties">
							<img src={this.props.route[0]=="properties"?'/' + process.env.REACT_APP_NAME + "/static/img/properties_g48.png":'/' + process.env.REACT_APP_NAME + "/static/img/properties.png"}
								style={{height: "22px !important", width: "22px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/leases`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Leases">
							<img src={this.props.route[0]=="leases"?'/' + process.env.REACT_APP_NAME + "/static/img/leases-green.png":'/' + process.env.REACT_APP_NAME + "/static/img/leases.png"}
								style={{height: "21px !important", width: "21px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/owners`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Owners">
							<img src={'/' + process.env.REACT_APP_NAME + "/static/img/owner_white.png"}
								style={{height: "21px !important", width: "21px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/repairmen`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Repairmen">
							<img src={'/' + process.env.REACT_APP_NAME + "/static/img/repairmen.png"}
								style={{height: "20px !important", width: "20px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/agents`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Agents">
							<img src={'/' + process.env.REACT_APP_NAME + "/static/img/agent.png"}
								style={{height: "20px !important", width: "20px", marginLeft: "-3px"}}
							/>
						</div>
					</Link>
					<Link to={`/manager/tenants`} style={{textDecoration: 'none', clear: "both"}}>
						<div  style={{height: "52px", width: "55px", textAlign:"center"}} title="Tenants">
							<img src={this.props.route[0]=="tenants"?'/' + process.env.REACT_APP_NAME + "/static/img/tenant-green.png":'/' + process.env.REACT_APP_NAME + "/static/img/tenants.png"}
								style={{height: "17px !important", width: "23px", marginLeft:"-5px"}}
							/>
						</div>
					</Link>
					{/*<div style={{textDecoration: 'none', clear: "both", cursor: "pointer"}}
						onClick={()=> {
							o.stopSync()
							global.usersDB.logout(function (err, response) {
								if (!err){
									o.clearLogin()
									o.logOut()
									o.history.pushState(null, '/manager/')
								}
							})
						}}
					>
						<table  style={{height: "52px", width: "100%"}} title={(o.open)?"":"Logout"}><tbody><tr>
							<td style={{verticalAlign: "middle", textAlign: "center", width: "44px"}}>
								<img src={'/' + process.env.REACT_APP_NAME + "/static/img/log-out-left.png"}
									style={{height: "21px !important", width: "23px", marginLeft: "-6px"}}
								/>
							</td>
							<td style={{verticalAlign: "middle", width: "220px"}}>
								<p style={{fontSize: "15px", color: '#9da8ad', marginLeft: "24px"}}>Logout</p>
							</td>
						</tr></tbody></table>
					</div>*/}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/LeftNavMenu.js